import React from 'react';
import PropTypes from 'prop-types';
import {Navigate, useParams} from 'react-router-dom';
import {buildPath} from '@tenant/core/routes';
import * as consts from '../../utils/constants';

/**
 * Sends an anonymous visitor from an alias path to login, with `back_url` set
 * to the *canonical* destination rather than the alias.
 *
 * `/v/7` -> `/login?back_url=%2Fviewings%2F7`, so login returns them to the
 * real route. Generalised from the old NavigateUnauthViewingsFeature.
 */
function NavigateAliasLoginFeature({to}) {
  const params = useParams();
  const target = buildPath(to, params);
  return (
    <Navigate
      to={`${consts.SLUG_LOGIN}?back_url=${encodeURIComponent(target)}`}
      replace
    />
  );
}

NavigateAliasLoginFeature.propTypes = {
  to: PropTypes.string.isRequired,
};

export default NavigateAliasLoginFeature;
